import styled, { keyframes, css } from 'styled-components';
import { IagrofyLogo, IagrofyLogoFull3 } from '../../atoms/AgroIcon/icons';
var LogoContainer = styled.a.withConfig({
  displayName: "StyledHeader__LogoContainer",
  componentId: "sc-10qnvt0-0"
})(["align-items:center;display:flex;justify-content:center;margin-right:115px;@media (max-width:", "){padding:4px;background:", ";margin:0px 16px 0px 11px;}@media (min-width:", ") and (max-width:", "){padding:4px;background:", ";margin:0px 16px 0px 4px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoint.md;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.green500;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoint.md;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoint.xl;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.green500;
});
var AgrofyLogo = styled(IagrofyLogo).withConfig({
  displayName: "StyledHeader__AgrofyLogo",
  componentId: "sc-10qnvt0-1"
})(["display:none;@media (max-width:", "){display:flex;}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoint.xl;
});
var AgrofyLogoFull = styled(IagrofyLogoFull3).withConfig({
  displayName: "StyledHeader__AgrofyLogoFull",
  componentId: "sc-10qnvt0-2"
})(["display:flex;max-width:148px;@media (max-width:", "){display:none;}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoint.xl;
});
var HamburgerButtonContainer = styled.div.withConfig({
  displayName: "StyledHeader__HamburgerButtonContainer",
  componentId: "sc-10qnvt0-3"
})(["display:inline-block;margin-left:auto;z-index:999;display:flex;justify-content:center;align-items:center;box-sizing:border-box;@media (min-width:", "){display:none;}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoint.lg;
});
var LeftContent = styled.div.withConfig({
  displayName: "StyledHeader__LeftContent",
  componentId: "sc-10qnvt0-4"
})(["display:flex;flex-grow:1;form{flex-grow:1;max-width:1000px;}@media (max-width:", "){form{min-width:auto;width:100%;}}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoint.lg;
});
var HeaderTagStyled = styled.header.withConfig({
  displayName: "StyledHeader__HeaderTagStyled",
  componentId: "sc-10qnvt0-5"
})(["top:0;left:0;width:100%;z-index:99999;position:sticky;"]);
var HeaderContainer = styled.div.withConfig({
  displayName: "StyledHeader__HeaderContainer",
  componentId: "sc-10qnvt0-6"
})(["display:flex;flex-direction:column;align-items:center;position:relative;background-color:", ";box-shadow:rgb(0 0 0 / 18%) 0px 2px 1px 0px;"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.gray200;
});
var MainHeader = styled.div.withConfig({
  displayName: "StyledHeader__MainHeader",
  componentId: "sc-10qnvt0-7"
})(["max-width:1600px;align-items:center;box-sizing:border-box;display:flex;height:54px;margin:0;padding:5px;justify-content:space-around;width:100%;@media (min-width:", "){height:66px;padding:12px;}@media (min-width:", "){padding:12px 44px;}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.breakpoint.md;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.breakpoint.xl;
});
var MenuContainer = styled.div.withConfig({
  displayName: "StyledHeader__MenuContainer",
  componentId: "sc-10qnvt0-8"
})(["height:calc(100vh - 94px);background-color:rgba(0,0,0,0.7);margin-bottom:0;overflow:auto;width:100%;position:absolute;top:100px;#menu-container{display:inline-block;}@media (max-width:767px){top:54px;}@media (max-width:", "){height:calc(100vh - 82px);#menu-container{display:block;}}"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.breakpoint.lg;
});
var MenuButton = styled.button.withConfig({
  displayName: "StyledHeader__MenuButton",
  componentId: "sc-10qnvt0-9"
})(["background-color:", ";padding:0px 20px;height:40px;font-size:14px;line-height:20px;border:1px solid ", ";margin-left:36px;margin-right:16px;padding:0px;width:125px;box-sizing:border-box;display:flex;justify-content:center;align-items:center;cursor:pointer;border-radius:8px;transition:all 0.3s ease;font-weight:500;font-family:", ";&:hover,&:focus{outline:none;}span{color:", ";}svg > path{fill:", ";}@media (max-width:", "){display:none;}@media (min-width:", ") and (max-width:", "){margin-left:0;}", ""], function (props) {
  return props.isActive ? props.theme.colors.gray700 : 'transparent';
}, function (props) {
  return props.isActive ? props.theme.colors.gray700 : props.theme.colors.gray500;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.fontFamily;
}, function (props) {
  return props.isActive ? props.theme.colors.white : props.theme.colors.gray800;
}, function (props) {
  return props.isActive ? props.theme.colors.white : props.theme.colors.gray800;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.breakpoint.lg;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.breakpoint.lg;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.breakpoint.xl;
}, function (_ref18) {
  var theme = _ref18.theme;
  return css(["border:1px solid ", ";color:", ";"], theme.colors.gray500, theme.colors.gray800);
});
var MobileSpinnerContainer = styled.div.withConfig({
  displayName: "StyledHeader__MobileSpinnerContainer",
  componentId: "sc-10qnvt0-10"
})(["position:absolute;top:40%;left:45%;@media (min-width:", "){display:none;}"], function (_ref19) {
  var theme = _ref19.theme;
  return theme.breakpoint.sm;
});
var CategoriesItem = styled.div.withConfig({
  displayName: "StyledHeader__CategoriesItem",
  componentId: "sc-10qnvt0-11"
})(["margin-left:24px;cursor:pointer;a{font-family:", ";font-style:normal;font-weight:400;font-size:14px;line-height:20px;text-decoration:none;display:flex;align-items:center;letter-spacing:-0.2px;color:", ";}"], function (_ref20) {
  var theme = _ref20.theme;
  return theme.fontFamily;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.gray900;
});
var CategoriesButton = styled.button.withConfig({
  displayName: "StyledHeader__CategoriesButton",
  componentId: "sc-10qnvt0-12"
})(["cursor:pointer;border:none;padding-right:24px;border-right:solid 1px #868e96;background-color:", ";font-family:", ";font-style:normal;font-weight:400;font-size:14px;line-height:20px;display:flex;align-items:center;letter-spacing:-0.2px;color:", ";a{margin-left:2px;}"], function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.gray200;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.fontFamily;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors.gray900;
});
var CategoriesContainer = styled.div.withConfig({
  displayName: "StyledHeader__CategoriesContainer",
  componentId: "sc-10qnvt0-13"
})(["height:24px;margin-bottom:15px;display:flex;align-self:start;margin-left:300px;align-items:center;letter-spacing:-0.2px;@media (min-width:1600px){width:1300px;align-self:center;overflow:none;}@media (max-width:", "){display:none;}"], function (_ref25) {
  var theme = _ref25.theme;
  return theme.breakpoint.xl;
});
var gradientBackground = keyframes(["0%{opacity:0.5;}50%{opacity:1;}100%{opacity:0.5;}"]);
var Loading = styled.div.withConfig({
  displayName: "StyledHeader__Loading",
  componentId: "sc-10qnvt0-14"
})(["margin-left:24px;height:18px;width:100px;background-color:", ";animation:", " 2s ease-in-out 0s infinite reverse;margin-right:16px;"], function (_ref26) {
  var theme = _ref26.theme;
  return theme.colors.gray500;
}, gradientBackground);
export { LogoContainer, HamburgerButtonContainer, AgrofyLogo, AgrofyLogoFull, HeaderTagStyled, HeaderContainer, MainHeader, MenuContainer, MenuButton, LeftContent, MobileSpinnerContainer, CategoriesContainer, CategoriesButton, CategoriesItem, Loading };